import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=1de83e23&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1de83e23')) {
      api.createRecord('1de83e23', component.options)
    } else {
      api.reload('1de83e23', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=1de83e23&", function () {
      api.rerender('1de83e23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25AQakYKHaSyn/JS/offershelp.vue"
export default component.exports